import { useMutation, useQuery } from "@tanstack/react-query";
import { createProjectGeofence, deleteProjectGeofence, getProjectGeofence, updateProjectGeofence } from "../api/geofence.service";
export const useGetProjectGeofenceDetailsQuery = (projectId, queryParams) => {
    return useQuery({
        enabled: false,
        gcTime: 0,
        queryFn: async () => {
            return await getProjectGeofence(projectId, queryParams);
        },
        queryKey: [
            "projectGeofenceDetails",
            projectId,
            queryParams.downSelectPartyNumber ?? null,
            queryParams.partyNumber ?? null
        ],
        retry: false
    });
};
export const useCreateProjectGeofenceMutate = (projectId, queryParams) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (projectGeofenceCreateRequest) => {
            return createProjectGeofence(projectId, queryParams, projectGeofenceCreateRequest);
        },
        retry: false
    });
};
export const useDeleteProjectGeofenceMutate = (projectId, queryParams) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (geofenceId) => {
            return deleteProjectGeofence(projectId, geofenceId, queryParams);
        },
        retry: false
    });
};
export const useUpdateProjectGeofenceMutate = (projectId, queryParams) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (updateProjectGeofenceRequest) => {
            return updateProjectGeofence(projectId, updateProjectGeofenceRequest.geofenceId, queryParams, updateProjectGeofenceRequest.requestBody);
        },
        retry: false
    });
};
